<template>
<div v-if="step" class="pa-3">
    <v-system-bar class="mb-5" window rounded>{{step.title}}</v-system-bar>
    <v-text-field xoutlined dense label="Title" v-model="step.title" hide-details class="mt-3" />
    <v-switch v-model="usedInTemplates" label="Used in templates and formulas" dense/>
    <v-text-field v-if="usedInTemplates" xoutlined dense label="Name" v-model="step.name" />
    <v-select xoutlined dense label="Type" v-model="step.type" :items="stepTypes"/>
    <v-select xoutlined dense label="Importance" v-model="step.important" :items="importanceLevels">
        <template v-slot:selection="{item}"> 
            <div :style="getBackgroundStyle(item.value)" style="padding-left:10px;background-size:120px;background-position:0px 0px;width:100%;min-width:200px;">{{item.text}}</div>
        </template>
        <template v-slot:item="{item}"> 
            <div :style="getBackgroundStyle(item.value)" style="padding-left:10px;background-size:120px;background-position:0px 0px;width:100%;min-width:200px;">{{item.text}}</div>
        </template>
    </v-select>
</div>
</template>

<script>
import StringHelpers from '../../helpers/StringHelpers'
// import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
            usedInTemplates: false,
            stepTypes: [
                'file', 'file/upload',
                'task',
                'text', 
                'true-false', 'true-false/switch', 'true-false/checkbox',
            ],
            importanceLevels: [
                {value: 0, text:'Normal'},
                {value: 1, text:'Hilight'},
                {value: 2, text:'Important'},
                {value: 3, text:'Urgent'},
            ]
        }
    },

    inject: ['$page'],

    components: {
        
    },
    
    props: {
        item: Object,
    },

    computed: {
        step() {
            return this.$page.activeStep || null
        }
    },

    methods: {
        getBackgroundStyle(value) {
            let style = {
                'background-image': `url(/static/images/hilight${value}.png)` 
            }
            if(value == 3) {
                style['padding-left'] = '25px'
                style['padding-top'] = '7px'
                style['height'] = '30px'
                style['background-size'] = 'contain'
            }
            return style
        },
    },

    created() {
        
    },

    watch: {
        'usedInTemplates': {
            handler: function(newVal) {
                if(!newVal)
                    this.step.name = ''
                else
                    this.step.name = StringHelpers.toSnakeCase(this.step.title)
            }
        }
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// StepDesigner.vue?533a09ec